module.exports = __webpack_public_path__ + "static/eaa222d9e825ca64b1067ede5164aa5e.svg";